import { call, fork, put, take, takeLatest } from 'redux-saga/effects';

import { acceptError } from 'common/_redux';
import { REQUEST } from 'redux-config/reduxHelpers';

import { getDealStatsSaga } from 'client/accounts/_redux/sagas';
import { getProfileSaga } from '../../../interface/user/_redux/sagas';

import * as api from '../api';
import * as ActionTypes from './actions';
import { getTradingAccountListSaga } from '../../_redux/commonSagas/sagas';

export function* getChallengesSaga() {
  try {
    const { data } = yield call(api.getChallenges);
    yield put(ActionTypes.getChallenges.success(data));
  } catch (e) {
    yield put(acceptError(e, true));
    yield put(ActionTypes.getChallenges.failure());
  }
}

export function* getChallengesWatcherSaga() {
  while (true) {
    yield take(ActionTypes.GET_CHALLENGES[REQUEST]);
    yield call(getChallengesSaga);
  }
}

export function* getUserChallengesSaga({ search }) {
  try {
    const { data } = yield call(api.getUserChallenges, search);
    yield put(ActionTypes.getUserChallenges.success(data));
  } catch (e) {
    yield put(acceptError(e, true));
    yield put(ActionTypes.getUserChallenges.failure());
  }
}

export function* getUserChallengesWatcherSaga() {
  yield takeLatest(ActionTypes.GET_USER_CHALLENGES[REQUEST], getUserChallengesSaga);
}

export function* activateChallengeSaga({ id, withdrawAccount, account, userChallengesParams }) {
  try {
    const { data, status } = yield call(api.activateChallenge, id, withdrawAccount, account);

    if (status < 300) {
      yield put(ActionTypes.activateChallenge.success(data));
      yield call(getUserChallengesSaga, userChallengesParams);
      yield call(getProfileSaga);
      yield call(getDealStatsSaga);
      yield call(getTradingAccountListSaga);
      yield call(getChallengesSaga);
    } else {
      const error = data?.challenge?.[0] || data?.detail || data;
      yield put(acceptError(error, false));
    }
  } catch (e) {
    yield put(acceptError(e, true));
    yield put(ActionTypes.activateChallenge.failure());
  }
}

export function* activateChallengeWatcherSaga() {
  while (true) {
    const { payload } = yield take(ActionTypes.activateChallenge.REQUEST);
    yield call(activateChallengeSaga, payload);
  }
}

export function* getChallengeSaga({ id }) {
  try {
    const { data } = yield call(api.getChallenge, id);
    yield put(ActionTypes.getChallenge.success(data));
  } catch (e) {
    yield put(acceptError(e, false));
    yield put(ActionTypes.getChallenge.failure());
  }
}

export function* getChallengeWatcherSaga() {
  while (true) {
    const payload = yield take(ActionTypes.GET_CHALLENGE[REQUEST]);
    yield call(getChallengeSaga, payload);
  }
}

export function* changeRefundableFeeRecieveMethodSaga({ challengeId, withdrawAccount }) {
  try {
    const { data, status } = yield call(api.changeRefundableFeeRecieveMethod, challengeId, withdrawAccount);

    console.log({ status });

    if (status < 300) {
      yield put(ActionTypes.changeRefundableFeeRecieveMethod.success(data));
      yield call(getChallengeSaga, { id: challengeId });
    } else {
      const error = data.detail ? data.detail : data;
      yield put(acceptError(error, false));
    }
  } catch (e) {
    yield put(acceptError(e, true));
    yield put(ActionTypes.changeRefundableFeeRecieveMethod.failure());
  }
}

export function* changeRefundableFeeRecieveMethodWatcherSaga() {
  while (true) {
    const { payload } = yield take(ActionTypes.changeRefundableFeeRecieveMethod.REQUEST);
    console.log(11, { payload });
    yield call(changeRefundableFeeRecieveMethodSaga, payload);
  }
}

export function* restartChallengeSaga({ id, withdrawAccount, account, userChallengesParams, onSuccess }) {
  try {
    const { data, status } = yield call(api.restartChallenge, id, withdrawAccount, account);
    if (status < 300) {
      yield put(ActionTypes.restartChallenge.success(data));
      if (onSuccess) {
        onSuccess(data);
      }
      if (userChallengesParams) {
        yield call(getUserChallengesSaga, userChallengesParams);
      }
      yield call(getProfileSaga);
      yield call(getDealStatsSaga);
      yield call(getTradingAccountListSaga);
      yield call(getChallengesSaga);
    } else {
      const error = data?.challenge?.[0] || data?.detail || data;
      yield put(acceptError(error, false));
    }
  } catch (e) {
    yield put(acceptError(e, true));
    yield put(ActionTypes.restartChallenge.failure());
  }
}

export function* restartChallengeWatcherSaga() {
  while (true) {
    const { payload } = yield take(ActionTypes.restartChallenge.REQUEST);
    yield call(restartChallengeSaga, payload);
  }
}

export function* archiveChallengeSaga({ id, onSuccess }) {
  try {
    const { data } = yield call(api.archiveChallenge, id);
    yield put(ActionTypes.archiveChallenge.success(data));
    if (onSuccess) {
      onSuccess();
    }
    yield call(getChallengesSaga);
  } catch (e) {
    yield put(acceptError(e, true));
    yield put(ActionTypes.archiveChallenge.failure());
  }
}

export function* archiveChallengeWatcherSaga() {
  while (true) {
    const payload = yield take(ActionTypes.ARCHIVE_CHALLENGE[REQUEST]);
    yield call(archiveChallengeSaga, payload);
  }
}

export function* getChallegesLeaderboardSaga({ search }) {
  try {
    const { status, data } = yield call(api.getChallegesLeaderboard, search);
    if (status < 300) {
      yield put(ActionTypes.getChallegesLeaderboard.success(data));
    } else {
      yield put(ActionTypes.getChallegesLeaderboard.failure(data.detail));
    }
  } catch (e) {
    yield put(acceptError(e, true));
    yield put(ActionTypes.getChallegesLeaderboard.failure());
  }
}

export function* getChallegesLeaderboardWatcherSaga() {
  yield takeLatest(ActionTypes.GET_CHALLENGES_LEADERBOARD[REQUEST], getChallegesLeaderboardSaga);
}

export function* manualWithdrawProfitFromChallengeSaga({ userChallengeId, amount }) {
  try {
    const { data, status } = yield call(api.manualWithdrawProfitFromChallenge, userChallengeId, amount);

    if (status < 300) {
      yield put(ActionTypes.manualWithdrawProfitFromChallenge.success(data));
      yield call(getProfileSaga);
      yield call(getUserChallengesSaga, { search: {} });
    } else {
      const error = data.detail ? data.detail : data;
      const manualError = typeof error === 'string' ? [error] : error;
      yield put(ActionTypes.manualWithdrawActionError(manualError));
      yield put(ActionTypes.manualWithdrawProfitFromChallenge.failure());
      // yield put(acceptError(error, false));
    }
  } catch (e) {
    console.log('catch');
    yield put(acceptError(e, true));
    yield put(ActionTypes.manualWithdrawProfitFromChallenge.failure());
  }
}

export function* manualWithdrawProfitFromChallengeWatcherSaga() {
  while (true) {
    const { payload } = yield take(ActionTypes.manualWithdrawProfitFromChallenge.REQUEST);
    yield call(manualWithdrawProfitFromChallengeSaga, payload);
  }
}

export default [
  fork(manualWithdrawProfitFromChallengeWatcherSaga),
  fork(changeRefundableFeeRecieveMethodWatcherSaga),
  fork(getChallengesWatcherSaga),
  fork(getUserChallengesWatcherSaga),
  fork(activateChallengeWatcherSaga),
  fork(getChallengeWatcherSaga),
  fork(restartChallengeWatcherSaga),
  fork(archiveChallengeWatcherSaga),
  fork(getChallegesLeaderboardWatcherSaga),
];
